import {Component, Input, OnInit} from '@angular/core';
import {CommentaireService} from '../../services/commentaire.service';
import {Commentaire} from '../../classes/commentaire';
import {AlertService} from '../../services/alert.service';
import {imgCardDrop} from '../../classes/animations';
import {MatDialog} from '@angular/material';
import {DeleteValidationDialogComponent, DeleteValidationDialogData} from '../delete-validation-dialog/delete-validation-dialog.component';
import {TRANSLATE} from '../../classes/translatable';
import {Pagination} from '../../../core/shared/classes/pagination';

@Component({
  selector: 'app-commentaires',
  templateUrl: './commentaires.component.html',
  styleUrls: ['./commentaires.component.css'],
  animations: [imgCardDrop]
})
export class CommentairesComponent implements OnInit {

  @Input() resourceType;
  @Input() resourceId;
  @Input() deleteAllowed = false;

  commentaires: Commentaire[] = [];
  pagination: Pagination = null;
  columnsToDisplay: string[] = ['date'];

  page = 1;
  perPage = 5;
  pageSizeOption  = [5, 10, 25, 100];

  constructor(
      private commentaireService: CommentaireService,
      private alertService: AlertService,
      private matDialog: MatDialog
  ) { }

  ngOnInit() {
    this.fetchItems();
  }

  fetchItems() {
    this.commentaireService.fetchAll(this.resourceType, this.resourceId, {page: this.page, perPage: this.perPage}).subscribe(response => {
      if (response.status === 200) {
        this.commentaires = [];
        response.data.data.forEach(item => this.commentaires.push(new Commentaire(item)));
        this.pagination = response.data.pagination;
      }
    });
  }

  createItem(commentaire: Commentaire) {
    this.commentaireService.createCommentaire(commentaire).subscribe(response => {
      if (response.status === 201) {
        this.alertService.success('Commentaire ajouté avec succès'); //TODO demander la traduction
        this.fetchItems();
      } else {
        this.alertService.warn(response.message);
      }
    });
  }

  deleteItem(commentaire: Commentaire) {
    this.commentaireService.deleteCommentaire(commentaire).subscribe(response => {
      if (response.status === 200) {
        this.alertService.success('Commentaire supprimé avec succès'); //TODO demander la traduction
        this.fetchItems();
      } else {
        this.alertService.warn(response.message);
      }
    });
  }

  submitEvent(commentaire: Commentaire) {
    if (commentaire && commentaire.content)
      this.createItem(commentaire);
  }

  onDeleteRequest(commentaire: Commentaire) {
    const data = new DeleteValidationDialogData();
    data.deleteMessage = TRANSLATE('Voulez-vous vraiment supprimer ce commentaire'); //TODO demander la traduction
    const dialog = this.matDialog.open(DeleteValidationDialogComponent, {data});

    dialog.afterClosed().subscribe(result => {
      if (result)
        this.deleteItem(commentaire);
    });
  }

  onPageChange($event) {
    if ($event.pageSize !== this.perPage) {
      this.perPage = $event.pageSize;
      this.fetchItems();
    } else if (($event.pageIndex + 1) !== this.page) {
      this.page = ($event.pageIndex + 1);
      this.fetchItems();
    }
  }
}
